// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"778":"ecf245ab","963":"22316afd"}[chunkId] + ".chunk.js";
};